import { EditRemoveActions, type DataGridConfig } from '@eo/shared';

import type { HolidayItem, TimeOffItem } from '../api/types';
import { formatHours } from '../helpers';

type TimeOffGridArgs = { onRemove: (row: TimeOffItem) => void };

export function makeTimeOffGridConfig({ onRemove }: TimeOffGridArgs): DataGridConfig<TimeOffItem> {
  return {
    getRowId: (row) => row.id,
    paramPrefix: 'pto_',
    rowTestId: 'timeoff-row',
    pagination: false,
    emptyState: { title: 'No time off logged this month.' },
    columns: [
      { id: 'date', header: 'Date', accessor: (row) => row.date },
      {
        id: 'hours',
        header: 'Hours',
        align: 'right',
        accessor: (row) => row.hours,
        cell: (row) => <span className="tabular-nums">{formatHours(row.hours)}</span>,
      },
      { id: 'source', header: 'Source', accessor: (row) => row.source },
      {
        id: 'notes',
        header: 'Notes',
        accessor: (row) => row.notes,
        cell: (row) => (
          <span className="block max-w-48 truncate text-sm text-text-tertiary">
            {row.notes || '—'}
          </span>
        ),
      },
      {
        id: 'actions',
        header: '',
        align: 'right',
        accessor: () => null,
        // ClickUp-sourced time off is owned upstream and must not be deletable here.
        cell: (row) =>
          row.source === 'manual' ? (
            <EditRemoveActions
              row={row}
              onRemove={onRemove}
              removeLabel={`Remove time off ${row.id}`}
            />
          ) : null,
      },
    ],
  };
}

export function makeHolidaysGridConfig(): DataGridConfig<HolidayItem> {
  return {
    getRowId: (row) => row.id,
    paramPrefix: 'hol_',
    rowTestId: 'holiday-row',
    pagination: false,
    emptyState: { title: 'No holidays configured for this country.' },
    columns: [
      { id: 'date', header: 'Date', accessor: (row) => row.date },
      { id: 'name', header: 'Name', accessor: (row) => row.name },
    ],
  };
}
